export default __webpack_public_path__ + "static/media/20A.39c65835.JPG";